<template>
	<div class="d-flex flex-wrap my-2">
		<div class="w-30 bg-white border mx-3 my-1 p-3 shadow">
			<h5 class="text-center">Text-to-Apply</h5>
			<p>
				Your HiringCenter account is equipped with text-to-apply functionality. Any prospects with a phone

				can easily apply to your job and enter your
				HiringCenter account simply by following the
				direction below.
			</p>
			<h5 class="text-center">Text <b>APPLY</b> to {{$parseNumber(user.Twilio)}}</h5>
			<p>
				Prospects will be prompted to provide their contact information to apply.
			</p>
		</div>
		<div class="w-30 bg-white border mx-3 my-1 p-3 shadow">
			<!-- <h4 class="text-center">HTTP POST</h4> -->
			<h5 class="text-center">Integration Documentation</h5>
			<!-- <p>
				You can connect your own web forms and application process to taTEXT
				by making an HTTP POST request to a webhook that we provide.
				Making a POST whenever you receive an apply will automatically
				create a new prospect in taTEXT.
			</p>
			<p>
				To request the HTTP POST Documentation, click the Support button to
				text your Client Services Representative.
			</p> -->

			<p>
				You can connect your own web form and application process to HiringCenter or 
				embed our custom-built web form into any webpage you own. By using our
				integration solutions, you can automatically create new prospects in HiringCenter
				whenever candidates submit their information.
			</p>
			<p style="text-align: center;">
				<b><u><a  @click="myFunction()">Download Integration PDF </a></u></b>
			</p>

		</div>
		<!-- <div v-if="isShowAfterClick" class="w-30 bg-white border mx-3 my-1 p-2 shadow">
			<h4 class="text-center">Custom Web Form</h4>
			<p>
				We can create a simple, custom web form and provide you with a single
				line of Iframe code that you can embed into any webpage you own.
			</p>
			<p>
				To request a custom Iframe web form, click the Support button to
				text your Client Services Representative.
			</p>
		</div> -->
	</div>
</template>

<script>
	import { mapState } from 'vuex'

	export default {
		name: "Integrations",
		computed: {
			...mapState('firebase', ['user'])
		},
		methods:{
			myFunction(){
				if (this.user && this.user.hasOwnProperty('Documentation') && this.user.Documentation){
					window.open(this.user.Documentation, "_blank");    
				}else {
					alert('Integration Documentation is not available. Contact HiringCenter Support to learn more.');
				}
				this.isShowAfterClick = false;
			}
		},
		data() {
			return {
				isShowAfterClick:true
			}
		}
	}
</script>

<style scoped>
</style>